/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var div = document.getElementsByClassName("main-product-meta")[0];
var MainAddToCart = document.querySelector("#ProductForm__AddToCart");
var SecoundButton = document.querySelector(".mobile_bottom_sticky_buttons");

// if (div) {
//   console.log(div.offsetTop);
//   if (window.innerWidth > 1007) {
//     var offset = div.offsetTop - 100;
//   }
//   else {
//     var offset = div.offsetTop - 200;
//   }
//   window.onscroll = function (e) {
//     if (window.scrollY >= offset) {
//       div.classList.add("bottom");
//     } else {
//       if (div.classList.contains("bottom")) {
//         div.classList.remove('bottom');
//       }
//     }
//   }
// }
// if (MainAddToCart) {
//   console.log(MainAddToCart.offsetTop);
//   if (window.innerWidth > 1007) {
//     var offset = MainAddToCart.offsetTop - 100;
//   }
//   else {
//     var offset = MainAddToCart.offsetTop - 200;
//   }
//   window.onscroll = function (e) {
//     if (window.scrollY >= offset) {
//       SecoundButton.classList.add("bottom");
//     } else {
//       if (SecoundButton.classList.contains("bottom")) {
//         SecoundButton.classList.remove('bottom');
//       }
//     }
//   }
// }

if (SecoundButton) {
  SecoundButton.addEventListener('click', function () {
    console.log('click on secound button')
    MainAddToCart.click();
  })
}

/**
 * Product Grid Size Swatches 
 * Add to cart functionality
 */
window.bindCollectionEvents = function () {
  var div = document.querySelectorAll(".js--ProductItem");

  div.forEach((item) => {
    let swatch = item.querySelectorAll(".SizeSwatch__Radio")
    button = item.querySelector(".Button--submit")
    popopen = item.querySelector(".js-open")
    popclose = item.querySelector(".js-close")

    popsubmit = item.querySelector(".PopButton--submit");

    swatch.forEach(size => {
      size.addEventListener('click', function () {
        var input = this.closest(".js--ProductItem").querySelector(".js--ProductVariant");
        console.log("input", input);
        input.value = this.dataset.variantId;
      })
    })

    button.addEventListener('click', function (event) {
      var submit = this.closest(".js--ProductItem").querySelector(".js--ProductSubmit");
      console.log("submit", submit);
      submit.click();

      //  window.HS_SLIDE_CART_OPENED = function() {
      //   console.log("test")
      //   window.HS_SLIDE_CART_SET_CART()
      // }
      //    submit.addEventListener("click", window.HS_SLIDE_CART_OPEN());
    });

    popsubmit.addEventListener('click', function () {
      var submit = this.closest(".js--ProductItem").querySelector(".js--ProductSubmit");
      submit.click();
    })
    if (item.querySelector(".js-open")) {
      popopen.addEventListener('click', function () {
        var popup = this.closest(".js--ProductItem").querySelector(".product_popup");
        document.querySelector('html').classList.toggle('show_contact');
        popup.classList.add('show');
      });
    }
    popclose.addEventListener('click', function () {
      var popup = this.closest(".js--ProductItem").querySelector(".product_popup");
      document.querySelector('html').classList.toggle('show_contact');
      popup.classList.remove('show');
    });
  });
  var popcloseAll = document.querySelector(".overlay_wrap");
  popcloseAll.addEventListener('click', function () {
    console.log('click!')
    var popup = document.querySelectorAll(".product_popup");
    popup.forEach(function (e) {
      document.querySelector('html').classList.toggle('show_contact');
      e.classList.remove('show');
    });
  });
}
window.onload = function () {
  /*- Bind Collection Events on Window Load -*/
  window.bindCollectionEvents();
}

var MainImageSlider = document.querySelector('.main_image_slider');
if(MainImageSlider){
  var flkty = new Flickity(MainImageSlider, {
    cellAlign: 'left',
    contain: true,
    "prevNextButtons": true,
    "pageDots": false,
    "adaptiveHeight": true,
    "dragThreshold": 8
  });
}

var ProductThumnailsSlider = document.querySelector('.Product__SlideshowNav--thumbnails_new_11');
if(ProductThumnailsSlider){
  var flkty = new Flickity(ProductThumnailsSlider, {
    asNavFor: '.main_image_slider',
    pageDots: false,
    percentPosition: false,
    "draggable": false,
    groupCells: '100%',
    "prevNextButtons": true,
    "adaptiveHeight": true
  });
}

var BottomThumbSlider = document.querySelector('.bottom_thumb_slider');
if(BottomThumbSlider){
  var flkty = new Flickity(BottomThumbSlider, {
    asNavFor: '.main_image_slider',
    pageDots: false,
    percentPosition: false,
    "draggable": false,
    groupCells: '100%',
    "prevNextButtons": true,
    //"adaptiveHeight": false,
    setGallerySize: false
  });
}
var ProductInfo = document.querySelector('.ProductForm');
var ProductColorGroup = document.querySelector('.Product_color_group');
if(ProductColorGroup){
  if(ProductColorGroup.scrollWidth > ProductInfo.clientWidth){  
    var flkty = new Flickity(ProductColorGroup, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      adaptiveHeight: true,
      groupCells: true
    });
  }
}

document.addEventListener("DOMContentLoaded", function(event) { 
  setTimeout(function () {
    var ProductAppSizeingChart = document.querySelector('.sizing-chart-container');
    var ProductAppSizeingChartBtn = document.querySelector('.ks-chart-modal-button');
    var ProductCustomSizeingChart = document.querySelector('.advice');
    var ProductCustomSizeingChartBtn = document.querySelector('.ProductForm__LabelLink');
    if(ProductAppSizeingChart){
      ProductCustomSizeingChart.classList.remove('no-js');
      ProductCustomSizeingChartBtn.addEventListener('click', function () {
        ProductAppSizeingChartBtn.click();
      });
    }
  }, 4500);
});


if(document.querySelector(".Product__Wrapper")){
  document.querySelector(".Product__Wrapper").setAttribute('style',`min-height:${document.querySelector(".Product__InfoWrapper .Product__Info").offsetHeight}px;`)
}

// Example with the Shopify them Dawn

// document.addEventListener("DOMContentLoaded", function(event) {
  
//    const drawerContent = document.querySelector(".hs-site-cart-popup-layout .hs-body-layout");
//    if(drawerContent){  
//     const miloCart = document.createElement("milo-cart-item");
//     drawerContent.appendChild(miloCart);
//    }
  
// });  


